import { render } from "./TableShips.vue?vue&type=template&id=2a0d2aa2&scoped=true"
import script from "./TableShips.vue?vue&type=script&lang=js"
export * from "./TableShips.vue?vue&type=script&lang=js"

import "./TableShips.vue?vue&type=style&index=0&id=2a0d2aa2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0d2aa2"]])

export default __exports__